// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Pi0w","title":"Images45_title__Lsza9","images":"Images45_images__2VuDn"};